export type ResourceSortField = 'createdAt' | 'updatedAt' | 'name';
export type ResourceSortOrder = 'asc' | 'desc';

export interface ResourceSortState {
  field?: ResourceSortField;
  order: ResourceSortOrder;
}

export const DEFAULT_RESOURCE_SORT: ResourceSortState = { field: undefined, order: 'desc' };

export const RESOURCE_SORT_FIELD_OPTIONS: Array<{
  value: ResourceSortField | undefined;
  label: string;
}> = [
  { value: undefined, label: '默认排序' },
  { value: 'createdAt', label: '新增时间' },
  { value: 'updatedAt', label: '更新时间' },
  { value: 'name', label: '名称' },
];

export function getResourceSortOrderOptions(field: ResourceSortField): Array<{
  value: ResourceSortOrder;
  label: string;
}> {
  if (field === 'name') {
    return [
      { value: 'asc', label: 'A → Z' },
      { value: 'desc', label: 'Z → A' },
    ];
  }

  return [
    { value: 'desc', label: '最新优先' },
    { value: 'asc', label: '最早优先' },
  ];
}

export function isDefaultResourceSort(sort: ResourceSortState): boolean {
  return sort.field === undefined;
}

export function toResourceSortParams(sort?: ResourceSortState): {
  sortBy?: ResourceSortField;
  sortOrder?: ResourceSortOrder;
} {
  if (!sort?.field) return {};
  return {
    sortBy: sort.field,
    sortOrder: sort.order,
  };
}
